
import { Component, ActionButtonConfig, FormModalMixins, menuRouteHelper, systemConst,Prop} from "@/lib";


@Component
export default class CreateCheckPointSetting extends FormModalMixins {

  model :any={};
  created(){
      Object.assign(this.config, {modelTitleL: "app.DeclareCustoms.InfoAll",labelWidth:100,width:600,isHideOk:true });
     
  }


 async  saveValue() {

   switch(this.model.fromType){
    case "1"  :
      this.$router.push({ name: "declareCustoms.invoice", query: {id:this.model.id} });
       break;
    case "2"  :
 this.$router.push({ name: "declareCustoms.packing", query: {id:this.model.id} });
       break; 
   case "3"  :
  this.$router.push({ name: "declarecustoms.customslist", query: {id:this.model.id} });
       break; 
    case "4"  :
    await this.$store.dispatch({type:"shipment/declarecustoms/checkdownloadDeclareProduct", id:this.model.id });
   this.$router.push({ name: "declarecustoms.productelement", query: {id:this.model.id} });
       break; 
     
}              
     this.close();
   
  }

  
    get infoList() {
        
        return [
            {value: "1", displayText: "发票单"},
            {value: "2", displayText: "装箱单"},
            {value: "3", displayText: "报关单"},
            {value: "4", displayText: "申报要素"},   
        ]
    }
       get record(){ 

      var tt=this.$store.state.shipment.declarecustoms.editDeclareCustoms;
      return tt
    };
}
